module.exports = __webpack_public_path__ + "img/looping_sm.1ab35306.png";